/** "Xm Ys" between a call's start and end, or '' when either is missing or invalid. */
export function callDuration(startedAt?: string, endedAt?: string): string {
    if (!startedAt || !endedAt) return ''
    const ms = new Date(endedAt).getTime() - new Date(startedAt).getTime()
    if (!Number.isFinite(ms) || ms <= 0) return ''
    const s = Math.round(ms / 1000)
    return `${Math.floor(s / 60)}m ${s % 60}s`
}
